import {
  TixologiTokenExchange,
  TixologiTokenScope,
} from "../../models/tixologi-token";

import { getApiClient } from "@punchup/utils/apiRegistry";
import { logException } from "@punchup/sentry";

/**
 * Exchanges the current Punchup session for a Tixologi token via
 * POST /api/v2/user/tixologi/token (POST — it mints a new token). `id` is
 * the comedian / venue_page id for the manager scopes; omit it for
 * `TixologiTokenScope.User` (any logged-in user can hold an end-user token).
 *
 * Throws on failure (network, unauthorized scope/id, Tixologi rejection) so
 * React Query can surface the error.
 */
export async function CLIENT_exchangeTixologiToken(
  scope: TixologiTokenScope,
  id?: string
): Promise<TixologiTokenExchange> {
  try {
    const response = await getApiClient().post<{ data: TixologiTokenExchange }>(
      "/api/v2/user/tixologi/token",
      { scope, id }
    );
    return response.data;
  } catch (error) {
    logException(error, {
      tags: { action: "CLIENT_exchangeTixologiToken" },
      extra: { scope, id },
    });
    throw error;
  }
}
